import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex w-full justify-between items-center" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "font-medium" }
const _hoisted_5 = { class: "font-bold text-xl" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["href"]

import {
	UiButton,
	SvgIcon,
	Tooltip,
	useConfirmation
} from '@/ui-kit';
import { useBilling } from '../composition';
import { computed, ref } from 'vue';
import { useToggle } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionTitle',
  setup(__props) {

const {
	currentSubItems,
	currentSubscriptionBillingPeriod,
	currentSubscription,
	isSubscriptionActive,
	isSubscriptionCanceled,
	getRenewalDate,
	cancelSubscription,
	resumeSubscription,
	getSubItemTotal,
	isSubscriptionIncomplete
} = useBilling();

const [isLoading, setIsLoading] = useToggle();

const totalPrice = computed(() => {
	return currentSubItems.value
		.reduce(
			(acc, curr) => acc + getSubItemTotal(curr),
			0
		)
		.toFixed(2)
		.padEnd(2, '.00');
});

const { openConfirmation, closeConfirmation } =
	useConfirmation();

const subscriptionTitle = computed(() => {
	return currentSubItems.value
		.map((item, i) => {
			const isLast =
				currentSubItems.value.length - 1 === i;
			const isPreLast =
				currentSubItems.value.length - 2 === i;
			const isFirst = i === 0;
			const divider =
				!isFirst && isPreLast
					? ' and '
					: !isLast
					? ', '
					: '';
			return `${item.friendlyName} ( x${item.quantity} )${divider}`;
		})
		.join('');
});

async function cancelPlan() {
	if (!currentSubscription.value) {
		return;
	}

	const result = await openConfirmation(
		`Are you sure you want to cancel your subscription?`,
		`Are you sure you want to cancel your subscription for products ${subscriptionTitle.value}? You will be able to still use the subscription or renew it until the end of current biling cycle.`,
		{
			confirmText: 'Cancel subscription',
			confirmTheme: 'danger',
			isLoading: computed(() => isLoading.value)
		}
	);

	if (!result) {
		return;
	}

	setIsLoading(true);
	await cancelSubscription();
	closeConfirmation();
	setIsLoading(false);
}

async function resumePlan() {
	setIsLoading();
	await resumeSubscription();
	setIsLoading(false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(subscriptionTitle)), 1),
        _createVNode(_unref(Tooltip), {
          disabled: 
						!_unref(currentSubscription)?.ends_at ||
						_unref(isSubscriptionCanceled)
					
        }, {
          popper: _withCtx(() => [
            _createTextVNode(" Your plan is canceled and still active until " + _toDisplayString(_unref(getRenewalDate)(
								_unref(currentSubscription)?.ends_at
							)), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["cursor-default font-bold text-sm text-white py-0.5 px-2 rounded-md capitalize flex gap-1 items-center", {
							'bg-green-400':
								_unref(isSubscriptionActive) &&
								!_unref(currentSubscription)?.ends_at,
							'bg-gray-400':
								_unref(isSubscriptionCanceled),
							'bg-yellow-500':
								_unref(isSubscriptionActive) &&
								!!_unref(currentSubscription)?.ends_at,
							'bg-red-400':
								!_unref(isSubscriptionActive) &&
								!_unref(isSubscriptionCanceled)
						}])
            }, [
              _createTextVNode(_toDisplayString(_unref(currentSubscription)?.stripe_status) + " ", 1),
              (
								_unref(currentSubscription)?.ends_at &&
								!_unref(isSubscriptionCanceled)
							)
                ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                    key: 0,
                    class: "h-4 w-4",
                    name: "info"
                  }))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      (!_unref(currentSubscription)?.ends_at)
        ? (_openBlock(), _createBlock(_unref(UiButton), {
            key: 0,
            loading: _unref(isLoading),
            class: "!text-sm font-medium !h-10",
            onClick: cancelPlan,
            theme: "danger-outlined"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel Plan ")
            ]),
            _: 1
          }, 8, ["loading"]))
        : (_openBlock(), _createBlock(_unref(UiButton), {
            key: 1,
            loading: _unref(isLoading),
            class: "!text-sm font-medium !h-10",
            theme: "primary-outlined",
            onClick: resumePlan
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Resume Plan ")
            ]),
            _: 1
          }, 8, ["loading"]))
    ]),
    _createElementVNode("div", _hoisted_5, " $" + _toDisplayString(_unref(totalPrice)) + " per " + _toDisplayString(_unref(currentSubscriptionBillingPeriod) ===
				'monthly'
					? 'month'
					: 'year'), 1),
    (
				_unref(isSubscriptionActive) && _unref(currentSubscription)
			)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_unref(currentSubscription)?.ends_at)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Your plan renews on " + _toDisplayString(_unref(getRenewalDate)(
						_unref(currentSubscription).created_at
					)) + ". ", 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, " Your plan is canceled and still active until " + _toDisplayString(_unref(getRenewalDate)(
						_unref(currentSubscription).ends_at
					)), 1))
        ], 64))
      : _createCommentVNode("", true),
    (
				_unref(isSubscriptionIncomplete) &&
				_unref(currentSubscription)?.invoices[0]
			)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: 
				_unref(currentSubscription).invoices[0]
					.hostedInvoiceUrl
			,
          target: "_blank"
        }, [
          _createVNode(_unref(UiButton), { class: "!h-10 !w-28 !min-w-28" }, {
            default: _withCtx(() => [
              _createTextVNode(" Pay Invoice ")
            ]),
            _: 1
          })
        ], 8, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}
}

})